export default {
  get_product_config_packaging: state => {return state.product_config_packaging},
  get_product_config_width: state => {return state.product_config_width},
  get_product_config_color: state => {return state.product_config_color},
  get_product_config_color_reference: state => {return state.product_config_color_reference},
  
  get_descm_long: state => {return state.descm_long},
  get_descm_court: state => {return state.descm_court},
  get_desc_prod: state => {return state.desc_prod},
  get_compo: state => {return state.compo},
  get_division_img: state => {return state.division_img},
  get_collection_card: state => {return state.collection_card},
  
  get_launch_config: state => {return state.launch_config},
  get_launch_stock: state => {return state.launch_stock},
  get_launch_price: state => {return state.launch_price},
   
  get_fmod: state => {return state.fmod},
  get_ftail1: state => {return state.ftail1},
  get_ftail2: state => {return state.ftail2},
  get_fopt: state => {return state.fopt},
  get_fcol: state => {return state.fcol},
  get_fmarq: state => {return state.fmarq},
  get_fgrpcol: state => {return state.fgrpcol},
  get_fqte: state => {return state.fqte},
  get_total_price: state => {return state.total_price},
  get_stock_availibility: state => {return state.stock_availibility},
  get_price_unit: state => {return state.price_unit},
  get_display_button_add_to_cart: state => {return state.display_button_add_to_cart}
}